import React from 'react'

import { Skeleton } from 'components'
import { BoxItem } from './StockKeepingUnitDetail'
import { SkeletonPreviewImage } from '../StockKeepingUnitPreviewImage'

const SkeletonStockKeepingDetail: React.FC = () => {
  const base = 'f-stock-keeping-unit-detail'

  const SkeletonDescription = () => {
    return (
      <>
        <div className={`${base}__image-layout`} data-testid='skeleton-loading'>
          <span className={`${base}__product-detail-title`}>
            {<Skeleton.whiteSkeleton width='177px' />}
          </span>
          {<SkeletonPreviewImage />}
        </div>
        <div className={`${base}__description-layout`}>
          <div className={`${base}__description-layout-status`}>
            <BoxItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={<Skeleton.whiteSkeleton width='121px' />}
            />
            <BoxItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={<Skeleton.whiteSkeleton width='121px' />}
            />
          </div>
          <BoxItem
            title={<Skeleton.whiteSkeleton width='56px' />}
            description={<Skeleton.whiteSkeleton width='228px' />}
          />
          <BoxItem
            title={<Skeleton.whiteSkeleton width='42px' />}
            description={<Skeleton.whiteSkeleton width='146px' />}
          />
          <BoxItem
            title={<Skeleton.whiteSkeleton width='74px' />}
            description={<Skeleton.whiteSkeleton width='121px' />}
          />
          <div className={`${base}__description-layout-status`}>
            <BoxItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={<Skeleton.whiteSkeleton width='121px' />}
            />
            <BoxItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={<Skeleton.whiteSkeleton width='121px' />}
            />
          </div>
          <BoxItem
            title={<Skeleton.whiteSkeleton width='42px' />}
            description={<Skeleton.whiteSkeleton width='146px' />}
          />
          <BoxItem
            title={<Skeleton.whiteSkeleton width='74px' />}
            description={<Skeleton.whiteSkeleton width='430px' />}
          />
        </div>
      </>
    )
  }
  return <SkeletonDescription />
}

export default SkeletonStockKeepingDetail
